import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import Box from '@mui/material/Box';
import {
  Alert,
  Grid, Stack, Typography,
} from '@mui/material';
import api from '../../../services/api';
import {ServiceReservationConfirmationCard} from "../components/ServiceReservationConfirmationCard";
import {Table} from "../components/Table";
import ReactDOM from "react-dom";
import {useGridApiRef} from "@mui/x-data-grid";
import {useStateContext} from "../../../hooks/useStateContext";
import {ChatDialog} from "../../../modules/service-provider/components/ChatDialog";
import {LoadingButton} from "@mui/lab";
import toast from "react-hot-toast";
import {ConfirmedList} from "../components/ConfirmedList";
import {AssignmentTurnedInRounded, HourglassBottomRounded} from "@mui/icons-material";
import {SkeletonCard} from "../components/SkeletonCard";

interface Props {
  data: any,
}

export const ActivityPage: React.ComponentType<Props> = ({data}) => {


  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: '100vh',
          overflow: 'auto',
          padding: '10px 0px'
        }}
      >

        <Table />

      </Box>
    </>
  );
};

function sleep(ms: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}